import { getCoreLevel } from '../../publicSession/selectors';
import { getMaxPriceForCoreLevel, getProfitMarginForCoreLevel, } from '../../utils/profits';
export var getProfitMargin = function (state) {
    var coreLevel = getCoreLevel(state);
    return getProfitMarginForCoreLevel(coreLevel);
};
export var getMaxPrice = function (state) {
    var coreLevel = getCoreLevel(state);
    return getMaxPriceForCoreLevel(coreLevel);
};
//# sourceMappingURL=selectors.js.map